module.exports = __webpack_public_path__ + "img/inStore.05d23fc0.png";